module.exports = "/_next/static/images/refresh-905804c6d67fadc0129e8cb1312a405d.svg";